<template>
    <div class="favorite-role-item">
        <div class="pixel-image" :style="'background-image: url(' + pixel_image.data.full_url + ')'"></div>
        <div class="name">{{ role.role_name }}</div>
        <div class="work">{{ role.role_work }}</div>
    </div>
</template>

<script>
    export default {
        name: 'FavoriteRoleItem',
        props: [
            'id',
            'role',
            'pixel_image',
        ],
        methods: {
        }
    };
</script>

<style scoped lang="less">
    .favorite-role-item {
        display: grid;
        grid-gap: 10px;
        text-align: center;

        & .pixel-image {
            width: 100%;
            height: 350px;
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
        }

        & .name {
            font-size: 22px;
            margin-top: 25px;
            font-weight: bold;
        }
        & .work {
            font-size: 16px;
        }
    }
</style>
